<script>
  import {format} from "date-fns"
  import {getAutoMpsProjectContext} from "../AutoMpsProjectContext.js";
  import Card from "../../components/layout/Card.svelte";
  import GreenChip from "../../components/chips/base/GreenChip.svelte";
  import BlueChip from "../../components/chips/base/BlueChip.svelte";
  import ViewCardBase from "../../components/views/cards/ViewCardBase.svelte";
  import Stack from "../../components/layout/Stack.svelte";
  import OrangeChip from "../../components/chips/base/OrangeChip.svelte";
  import RedChip from "../../components/chips/base/RedChip.svelte";
  import ExecutionStatusChip from "./ExecutionStatusChip.svelte";

  export let execution

  const autoMpsProjectContext = getAutoMpsProjectContext()
  const projectId = $autoMpsProjectContext.projectId
  const executionId = execution.id

  const views = {
   LoadGraph_MPS: {
      iconSrc: "/assets/icons/icon_load_graph_mps.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/load-graph`,
      name: {
        ja: "負荷グラフ (MPS)",
      },
    },
    PSIGraph: {
      iconSrc: "/assets/icons/icon_psi_graph.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/psi-graph`,
      name: {
        ja: "PSIグラフ",
      },
    },
    PSITable_MPS: {
      iconSrc: "/assets/icons/icon_psi_table_mps.png",
      href: `/auto-mps/projects/${projectId}/executions/${executionId}/views/psi-table`,
      name: {
        ja: "PSI表",
      },
    },
  }

  $: title = execution?.scheduledAt ? format(execution.scheduledAt, "yyyy年M月d日 H時m分s秒") : "(unknown)"
</script>

<Card width="100%">
  <div style="display: inline-flex; justify-content: space-between; width: 100%"  slot="title">
    <div style="display: inline-flex; gap: 1rem; align-items: center">
      <span style="font-weight: bold; font-size: 1.1rem">{title}</span>
      <span style="color: darkgrey; font-size: .9rem;">(id: {execution.id})</span>
    </div>
    <div>
      <ExecutionStatusChip status={execution.status} />
    </div>
  </div>
  <Stack direction="vertical">
    <Stack direction="horizontal">
      <div>計画パラメタ: {execution.schedulingParameter}</div>
      <div>
        実行方法:
        {#if execution.planId}
          手動
        {/if}
        {#if execution.scheduleId}
          自動実行
        {/if}
      </div>
    </Stack>
    {#if execution.status === "executed"}
      <div style="width: 100%">
        <div class="view-button-cards-container">
          {#each Object.keys(views) as viewName}
            <ViewCardBase
              viewIconSrc={views[viewName].iconSrc}
              href={views[viewName].href}
            >
              <span>{@html views[viewName].name.ja}</span>
            </ViewCardBase>
          {/each}
        </div>
      </div>
    {/if}
  </Stack>
</Card>

<style>
  .view-button-cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
  }
</style>
